export const LocalStorageKeys = {
  MasterID: 'masterIdPreset',
  StartedFromWizard: 'startedFromWizard',
  WizardStep: 'wizardStep',
  TermsAndConditions: 'termsAndConditions',
  LSClearCounter: 'lSClearCounter',
  WizardStepsPassed: 'wizardStepsPassed',
  HasInvestorAccount: 'hasInvestorAccount',
  AccountType: 'accountType',
};
